import { connect } from 'react-redux'
import { selectors as backendSelectors } from '../../features/Backend'
import SideContainer from '../../components/SideContainer'
import localizeImport from '../../store/localize'
import getAttributes from '../../settings/attributes'
import strings from '../../components/SideContainer/side-container.json'
import { launcherOpenUrl } from '../../launcherBackend/launcher-command'

function mapStateToProps(state) {
    const locale = backendSelectors.getLocale(state)
    const attributes = getAttributes(locale)
    const localize = value => localizeImport(strings, locale, value)
    return {
        feedback: {
            type: 'feedback',
            description: localize('feedback'),
            link: attributes.link.feedbackButton,
        },
        bugreport: {
            type: 'bug',
            description: localize('bugreport'),
            link: attributes.link.bugReportButton,
        },
        externalLinkText: localize('externalLink'),
        launcherOpenUrl,
    }
}

export default connect(mapStateToProps)(SideContainer)



// WEBPACK FOOTER //
// ./src/containers/SideContainer/side-container.js